import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import DialogComponent from "../HelperComponents/DialogComponent/DialogComponent";
import nonAvatart from "../../assets/image/non-avatar.png";
import cartCloseBtn from "../../assets/image/cart_close_btn.svg";
import cartStockWarning from "../../assets/image/cart_stock_warning.svg";
import cartPlus from "../../assets/image/plus.svg";
import cartMinus from "../../assets/image/minus.svg";
import Discount_edit from "../../assets/image/discount_edit.svg";
import DefaultButton from "../HelperComponents/DefaultButton/DefaultButton";
import { Link } from "react-router-dom";
import saleBadge from "../../assets/image/sale-badge.svg";
import topSalesBadge from "../../assets/image/top-sales.svg";
import {
    GetClientInfo,
    sessionEnd,
    setNeedDelivery,
    setAddress,
    setDate,
    cartUpdate,
} from "../../actions/clientAuthActions";
import { toFixedNoRounding } from "../../helpers/functions";

let CartDialog = (props) => {
    const { GetClientInfo, cartUpdate, handleSubmit } = props;


    const [cart, setCart] = useState(() => {
        const savedCart = localStorage.getItem("cart");
        return savedCart ? JSON.parse(savedCart) : [];
    });
    const [quantityModalData, setQuantityModalData] = useState(null);


    useEffect(() => {
        GetClientInfo(localStorage.getItem("client_phone"));
    }, [GetClientInfo]);

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart));
        cartUpdate();
    }, [cart, cartUpdate]);


    const handlePurchaseValue = (sign, index) => {
        const newCart = cart.map((item, idx) => {
            if (idx === index) {
                const currentAmount = Number(item.amount);
                const newAmount = sign === "+" ? currentAmount + 1 : currentAmount - 1;
                return { ...item, amount: newAmount > 0 ? newAmount : 1 };
            }
            return item;
        });
        setCart(newCart);
    };

    const handleModalInputChange = (value) => {
        if (!quantityModalData) return;

        const newAmount = value === "" ? "" : Number(value);

        if (newAmount === "" || (Number.isInteger(newAmount) && newAmount >= 0)) {
            const { item, index } = quantityModalData;
            const updatedItem = { ...item, amount: newAmount };

            setQuantityModalData({ item: updatedItem, index });

            const newCart = [...cart];
            newCart[index] = updatedItem;
            setCart(newCart);
        }
    };

    const deleteCartItem = (event) => {
        const type = event.target.dataset.type;
        const index = parseInt(event.target.dataset.id, 10);
        let newCart;

        switch (type) {
            case "all":
                newCart = cart
                    .map((el) =>
                        el.item.has_id_1c === false
                            ? null
                            : el.amount > el.stock
                                ? { ...el, amount: el.stock }
                                : el
                    )
                    .filter((el) => el !== null && el.stock > 0);
                break;
            case "in":
                newCart = cart.filter((_, i) => i !== index);
                break;
            case "out":
                const target = cart[index];
                if (target.item.has_id_1c === false) {
                    newCart = cart.filter((_, i) => i !== index);
                } else {
                    newCart = cart.map((item, i) =>
                        i === index ? { ...item, amount: item.stock } : item
                    ).filter(item => item.amount > 0);
                }
                break;
            default:
                newCart = [...cart];
                break;
        }
        setCart(newCart);
    };

    const openQuantityModal = (element, idx) => {
        setQuantityModalData({ item: element, index: idx });
    };

    const closeQuantityModal = () => {
        setQuantityModalData(null);
    };

    // Мемоізовані списки товарів, щоб уникнути зайвих перерахунків при рендері
    const { inStockItems, outOfStockItems } = useMemo(() => {
        const inStock = [];
        const outOfStock = [];

        cart.forEach((item, index) => {
            const itemWithIndex = { ...item, originalIndex: index };
            if (item.item.has_id_1c === true && item.stock > 0) {
                inStock.push(itemWithIndex);
            }
            if (item.item.has_id_1c === false || (item.amount > item.stock && item.item.has_id_1c === true)) {
                outOfStock.push(itemWithIndex);
            }
        });

        return { inStockItems: inStock, outOfStockItems: outOfStock };
    }, [cart]);


    return (
        <div className="client_page with_cart">
            <div className={`client_content client_info cart${inStockItems.length > 0 ? "" : " empty"}`}>
                <div>
                    <div className="name">Товары в наличии </div>
                </div>
                {inStockItems.length > 0 ? (
                    <div className="cart-item">
                        {inStockItems.map((el) => (
                            <div key={el.originalIndex} className="cart-item container">
                                <div className="image-wrapper">
                                    <img
                                        src={el.item.images.length > 0 ? el.item.images[0] : nonAvatart}
                                        alt="Cart item"
                                    />
                                </div>
                                <div className="info-wrapper">
                                    <div className="info header">
                                        <Link
                                            to={`/main/shop/product/${el && el.item ? el.item.id : ''}`}
                                            className="heading"
                                        >
                                            {el && el.item ? el.item.name : '—'}
                                            <span className="price-indicator">
                                                {el && el.priceType
                                                    ? el.priceType.includes('retail')
                                                        ? 'Розничная цена'
                                                        : 'Оптовая цена'
                                                    : 'Ціна не вказана'}
                                            </span>
                                        </Link>
                                        <img
                                            className="delete" src={cartCloseBtn} alt="Delete cart item"
                                            data-type="in" data-id={el.originalIndex} onClick={deleteCartItem}
                                        />
                                    </div>
                                    <div className="info body">
                                        <div className="input_add">
                                            <img
                                                src={cartMinus} alt="cartminus"
                                                onClick={() => handlePurchaseValue("-", el.originalIndex)}
                                                style={el.amount <= 1 ? { opacity: "0.3" } : {}}
                                                className="cart-minus"
                                            />
                                            <input
                                                value={el.amount > el.stock ? el.stock : el.amount}
                                                readOnly disabled
                                            />
                                            <img
                                                src={cartPlus} alt="cartplus"
                                                onClick={() => handlePurchaseValue("+", el.originalIndex)}
                                                className="cart-plus"
                                            />
                                            <img
                                                src={Discount_edit} className="edit_btn" alt="Edit quantity"
                                                onClick={() => openQuantityModal(el, el.originalIndex)}
                                            />
                                        </div>
                                        <div className="price">
                                            {(el.item.discount_price || !!el.discount) && (
                                                <span className="discount">{toFixedNoRounding(el.item[el.priceType], 2)} грн</span>
                                            )}
                                            <span>
                                                {toFixedNoRounding(
                                                    !!el.discount
                                                        ? el.item[el.priceType] - (el.item[el.priceType] * el.discount) / 100
                                                        : el.item.discount_price || el.item[el.priceType],
                                                    2
                                                )} грн
                                            </span>
                                            {el.item.sale ? <img src={saleBadge} alt="sale" style={{ marginLeft: "40px" }} />
                                                : el.item.top_sales ? <img src={topSalesBadge} alt="topSales" style={{ marginLeft: "40px" }} />
                                                    : null}
                                        </div>
                                    </div>
                                    {el.amount > el.stock && (
                                        <div className="info footer">
                                            <img src={cartStockWarning} alt="Cart stock warning" />
                                            <span>Только {el.stock} в наличии на складе. {el.amount - el.stock} - под заказ!</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : <p>Нет товаров.</p>}
            </div>

            {outOfStockItems.length > 0 && (
                <div className='client_content client_info cart'>
                    <div>
                        <div className="name">Товары под заказ </div>
                        <button className="clear_cart" data-type="all" onClick={deleteCartItem}>Очистить</button>
                    </div>
                    <div className="cart-item">
                        {outOfStockItems.map((el) => (
                            <div key={el.originalIndex} className="cart-item container">
                                <div className="image-wrapper">
                                    <img src={el.item.images.length > 0 ? el.item.images[0] : nonAvatart} alt="Cart item" />
                                </div>
                                <div className="info-wrapper">
                                    <div className="info header">
                                        <Link
                                            to={`/main/shop/product/${el && el.item ? el.item.id : ''}`}
                                            className="heading"
                                        >
                                            {el && el.item ? el.item.name : '—'}
                                            <span className="price-indicator">
                                                {el && el.priceType
                                                    ? el.priceType.includes('retail')
                                                        ? 'Розничная цена'
                                                        : 'Оптовая цена'
                                                    : 'Ціна не вказана'}
                                            </span>
                                        </Link>
                                        <img className="delete" src={cartCloseBtn} alt="Delete cart item"
                                            data-type="out" data-id={el.originalIndex} onClick={deleteCartItem} />
                                    </div>
                                    <div className="info body">
                                        <div className="input_add">
                                            <img src={cartMinus} alt="cartminus"
                                                onClick={() => handlePurchaseValue("-", el.originalIndex)}
                                                style={el.amount <= 1 ? { opacity: "0.3" } : {}} className="cart-minus" />
                                            <input
                                                value={el.item.has_id_1c === false ? el.amount : el.amount - el.stock}
                                                readOnly disabled
                                            />
                                            <img src={cartPlus} alt="cartplus"
                                                onClick={() => handlePurchaseValue("+", el.originalIndex)} className="cart-plus" />
                                            <img src={Discount_edit} className="edit_btn" alt="Edit quantity"
                                                onClick={() => openQuantityModal(el, el.originalIndex)} />
                                        </div>
                                        <div className="price">
                                            {(el.item.discount_price || !!el.discount) && (
                                                <span className="discount">{toFixedNoRounding(el.item[el.priceType], 2)} грн</span>
                                            )}
                                            <span>
                                                {toFixedNoRounding(
                                                    !!el.discount
                                                        ? el.item[el.priceType] - (el.item[el.priceType] * el.discount) / 100
                                                        : el.item.discount_price || el.item[el.priceType],
                                                    2
                                                )} грн
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <DialogComponent open={!!quantityModalData} onClose={closeQuantityModal}>
                {quantityModalData && (
                    <form onSubmit={handleSubmit(closeQuantityModal)}>
                        <div className="dialog_client quantity">
                            <div className="modal_title">Изменение количества товара</div>
                            <div className="info body">
                                <div className="input_add">
                                    <input
                                        type="number"
                                        value={quantityModalData.item.amount}
                                        onChange={(e) => handleModalInputChange(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                            </div>
                            {quantityModalData.item.item.has_id_1c !== false && quantityModalData.item.amount > quantityModalData.item.stock && (
                                <div className="info footer">
                                    <img src={cartStockWarning} alt="Cart stock warning" />
                                    <span>
                                        Только {quantityModalData.item.stock} в наличии на складе.{" "}
                                        {quantityModalData.item.amount - quantityModalData.item.stock} - под заказ!
                                    </span>
                                </div>
                            )}
                            <div className="button_container">
                                <DefaultButton variant="contained" type="submit">
                                    Сохранить
                                </DefaultButton>
                            </div>
                        </div>
                    </form>
                )}
            </DialogComponent>
        </div>
    );
};

const validate = values => {
    const errors = {};
    if (!values.email) {
        errors.email = "Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2, 5}$/i.test(values.email)) {
        errors.email = "Invalid email";
    }
    if (!values.password) {
        errors.password = "Required";
    } else if (values.password.length < 8) {
        errors.password = "Must be 8 characters or more";
    }
    return errors;
};

const DecoratedCartDialog = reduxForm({
    form: "CartDialogForm",
    validate
})(CartDialog);

const mapStateToProps = ({ client }) => ({
    clientInfo: client.client_info,
    needDelivery: client.needDelivery,
    selectedDate: client.selectedDate,
    deliveryAddress: client.deliveryAddress
});

const mapDispatchToProps = {
    GetClientInfo,
    sessionEnd,
    cartUpdate,
    setNeedDelivery,
    setAddress,
    setDate
};

export default connect(mapStateToProps, mapDispatchToProps)(DecoratedCartDialog);